// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './SubmitButton.scss';
import CircleLoader from '../CircleLoader/CircleLoader';

@observer class SubmitButton extends Component<any, any> {
	render() {
		return (
			<div className={this.props.loading ? "submit-wrapper loading" : "submit-wrapper"}>
				<button type="submit">{this.props.text}</button>
				{this.props.loading ? 
					<CircleLoader color='#fff' size={25} />
				: null}
			</div>
		)
	}
}

export default SubmitButton;

